import Grid from '@mui/material/Grid';

import MonthlySalesReportChart from './chart-component';
import MonthlySalesReportTable from './table-component';

const MonthlySalesReportContent = (props) => {
  return (
    <Grid item size={{ xs: 12 }}>
      <Grid container mt={7}>
        <Grid item size={{ xs: 12, md: 12 }}>
          <MonthlySalesReportChart props={props} />
        </Grid>
        <Grid item size={{ xs: 12, md: 12 }}>
          <MonthlySalesReportTable props={props} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MonthlySalesReportContent;
